<template>
  <b-modal :active.sync="show" aria-modal>
    <div class="has-text-centered">
      <img v-if="media.type === 'image'" :src="(media.storageType == null) ? media.images.original.link : media.values.thumbnailLink" alt="">

      <iframe v-else-if="media.type === 'document' && media.storageType == null" :src="`https://docs.google.com/gview?embedded=true&url=${media.file.link}`" style="width: 75%; height: 90vh;"></iframe>

      <video-manager v-else-if="['video', 'youtube'].indexOf(media.type) > -1" :videos="[media]"></video-manager>
    </div>
    <button type="button" class="modal-close is-large" @click.prevent="show = false"></button>
  </b-modal>
</template>

<script>
import VideoManager from '~/components/VideoManager';

export default {
  components: {
    VideoManager
  },

  props: {
    media: {
      type: Object,
      required: true
    },
    onHide: {
      type: Function,
      required: true
    }
  },

  watch: {
    show(val) {
      if (!val) {
        this.onHide();
      }
    }
  },

  data() {
    return {
      show: true
    }
  }
}
</script>
